/**
 * App-shell scroll padding vs page-level sticky headers.
 *
 * AdminLayout, DashboardLayout, and AssetAdminLayout put `p-4 md:p-6` on the
 * scrolling `<main>`. CSS sticky insets resolve inside that padding, so
 * `top-0` leaves a 16/24px strip where already-scrolled rows remain visible
 * above the frozen header.
 *
 * Use this class on page-level sticky headers and accordion sticky wrappers.
 * Keep `top-0` only inside an unpadded nested scroller.
 */
export const APP_SHELL_STICKY_TOP_CLASS = '-top-4 md:-top-6';
